import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';

import SocialImpactEmailPage from '../components/company/socialimpact-email-page/socialimpact-email-page';

const SocialImpactEmailRoute = () => (
  <Fragment>
    <DocumentTitle title="Social Impact Email | NerdWallet" />
    <SocialImpactEmailPage />
  </Fragment>
);

SocialImpactEmailRoute.displayName = 'Social Impact Email Route';
SocialImpactEmailRoute.analyticsName = 'socialimpact_email_page';
SocialImpactEmailRoute.segmentPageName = 'social_impact_email';

export default SocialImpactEmailRoute;
